import i18next from 'i18next';

i18next.addResources('es', 'stagesNames', {
  profiling: 'Perfil',
  // eslint-disable-next-line camelcase
  pre_execution: 'Pre-Ejecución',
  execution: 'Ejecución',
  finished: 'Concluido'
});

i18next.addResources('en', 'stagesNames', {
  profiling: 'Profile',
  // eslint-disable-next-line camelcase
  pre_execution: 'Pre-Execution',
  execution: 'Execution',
  finished: 'Completed'
});

i18next.addResources('pt', 'stagesNames', {
  profiling: 'Perfil',
  // eslint-disable-next-line camelcase
  pre_execution: 'Pré-Execução',
  execution: 'Execução',
  finished: 'Concluído'
});

i18next.addResources('es', 'SEO', {
  homeTitle: 'ILAT',
  homeDescription: 'ILAT innovamos en infraestructura de integración.',
  projectsTitle: 'Proyectos | ILAT',
  projectsDescription:
    'Proyectos de ILAT desarrollados, en desarrollo o próximos a desarrollar de energía, fronteras, telecomunicaciones y transporte.',
  digitalTitle: 'Contenidos | ILAT',
  digitalDescription: 'Encuentra publicaciones, videos, noticias y más publicados por ILAT.',
  eventsTitle: 'Eventos | ILAT',
  eventsDescription: 'Encuentra conferencias, seminarios, talleres y más organizados por ILAT.',
  projectDetailTitle: 'Detalle de Proyecto | ILAT',
  projectDetailDescription: 'Detalle del proyecto organizado por ILAT.',
  projectTechnicalTitle: 'Ficha Técnica de Proyecto | ILAT',
  projectTechnicalDescription: 'Detalle de la ficha técnica del proyecto organizado por ILAT.',
  scheduleTitle: 'Calendario del Evento | ILAT',
  scheduleDescription: 'Calendario de la conferencia ó seminario ó taller organizado por ILAT.',
  whatWeDoTitle: 'Qué hacemos | ILAT',
  whatWeDoDescription: 'ILAT es tecnología puesta al servicio de la infraestructura de integración.',
  eventDetailTitle: 'Detalle de Evento | ILAT',
  eventDetailDescription: 'Detalle de la conferencia ó seminario ó taller organizado por ILAT.',
  articleDetailTitle: 'Detalle de Contenido | ILAT',
  articleDetailDescription: 'Detalle de la publicación ó video ó noticia publicado por ILAT.',
  searchTitle: 'Búsqueda | ILAT',
  searchDescription:
    'Resultado de la búsqueda aplicando filtros para buscar un evento, contenido o proyecto de ILAT.',
  iirsaProjectsTitle: 'Proyectos IIRSA | ILAT',
  iirsaProjectsDescription:
    'Proyectos de IIRSA desarrollados, en desarrollo o próximos a desarrollar de energía, fronteras, telecomunicaciones y transporte.',
  notFoundTitle: 'Recurso no encontrado | ILAT',
  notFoundDescription: 'Página 404 sin registros encontrados.'
});

i18next.addResources('en', 'SEO', {
  homeTitle: 'ILAT',
  homeDescription: 'ILAT innovating in integration infrastructure.',
  projectsTitle: 'Projects | ILAT',
  projectsDescription:
    'ILAT projects developed, under development or upcoming in energy, borders, telecommunications and transportation.',
  digitalTitle: 'Content | ILAT',
  digitalDescription: 'Find publications, videos, news and more published by ILAT.',
  eventsTitle: 'Events | ILAT',
  eventsDescription: 'Find conferences, seminars, workshops and more organized by ILAT.',
  projectDetailTitle: 'Project Detail | ILAT',
  projectDetailDescription: 'Detail of the project organized by ILAT.',
  projectTechnicalTitle: 'Project Technical Sheet | ILAT',
  projectTechnicalDescription: 'Detail of the project technical sheet organized by ILAT.',
  scheduleTitle: 'Event Schedule | ILAT',
  scheduleDescription: 'Schedule of the conference or seminar or workshop organized by ILAT.',
  whatWeDoTitle: 'What We Do | ILAT',
  whatWeDoDescription: 'ILAT is technology at the service of integration infrastructure.',
  eventDetailTitle: 'Event Detail | ILAT',
  eventDetailDescription: 'Detail of the conference or seminar or workshop organized by ILAT.',
  articleDetailTitle: 'Content Detail | ILAT',
  articleDetailDescription: 'Detail of the publication or video or news published by ILAT.',
  searchTitle: 'Search | ILAT',
  searchDescription:
    'Search results applying filters to find an event, content or project from ILAT.',
  iirsaProjectsTitle: 'IIRSA Projects | ILAT',
  iirsaProjectsDescription:
    'IIRSA projects developed, under development or upcoming in energy, borders, telecommunications and transportation.',
  notFoundTitle: 'Resource Not Found | ILAT',
  notFoundDescription: '404 page with no records found.'
});

i18next.addResources('pt', 'SEO', {
  homeTitle: 'ILAT',
  homeDescription: 'ILAT inovamos em infraestrutura de integração.',
  projectsTitle: 'Projetos | ILAT',
  projectsDescription:
    'Projetos da ILAT desenvolvidos, em desenvolvimento ou próximos a desenvolver em energia, fronteiras, telecomunicações e transporte.',
  digitalTitle: 'Conteúdo | ILAT',
  digitalDescription: 'Encontre publicações, vídeos, notícias e mais publicados pela ILAT.',
  eventsTitle: 'Eventos | ILAT',
  eventsDescription: 'Encontre conferências, seminários, oficinas e mais organizados pela ILAT.',
  projectDetailTitle: 'Detalhe do Projeto | ILAT',
  projectDetailDescription: 'Detalhe do projeto organizado pela ILAT.',
  projectTechnicalTitle: 'Ficha Técnica do Projeto | ILAT',
  projectTechnicalDescription: 'Detalhe da ficha técnica do projeto organizado pela ILAT.',
  scheduleTitle: 'Agenda do Evento | ILAT',
  scheduleDescription: 'Agenda da conferência ou seminário ou oficina organizado pela ILAT.',
  whatWeDoTitle: 'O Que Fazemos | ILAT',
  whatWeDoDescription: 'ILAT é tecnologia a serviço da infraestrutura de integração.',
  eventDetailTitle: 'Detalhe do Evento | ILAT',
  eventDetailDescription: 'Detalhe da conferência ou seminário ou oficina organizado pela ILAT.',
  articleDetailTitle: 'Detalhe do Conteúdo | ILAT',
  articleDetailDescription: 'Detalhe da publicação ou vídeo ou notícia publicado pela ILAT.',
  searchTitle: 'Busca | ILAT',
  searchDescription:
    'Resultado da busca aplicando filtros para encontrar um evento, conteúdo ou projeto da ILAT.',
  iirsaProjectsTitle: 'Projetos IIRSA | ILAT',
  iirsaProjectsDescription:
    'Projetos da IIRSA desenvolvidos, em desenvolvimento ou próximos a desenvolver em energia, fronteiras, telecomunicações e transporte.',
  notFoundTitle: 'Recurso Não Encontrado | ILAT',
  notFoundDescription: 'Página 404 sem registros encontrados.'
});
